
const digest = '5818f59b359babe7da37f1bf43d7f9da1bd3829c980136d5b630a5decea19739';
const classes = {"wrapper":"_wrapper_beuct_1","options":"_options_beuct_9","list":"_list_beuct_18","noData":"_noData_beuct_47"};
const css = `._wrapper_beuct_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  background: #ffffff;
}
._wrapper_beuct_1 ._options_beuct_9 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_beuct_1 ._list_beuct_18 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  background: #f9fdff;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_beuct_1 ._list_beuct_18::-webkit-scrollbar {
  display: block;
}
._wrapper_beuct_1 ._list_beuct_18::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_beuct_1 ._list_beuct_18::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_beuct_1 ._list_beuct_18::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_beuct_1 ._list_beuct_18::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_beuct_1 ._list_beuct_18 ._noData_beuct_47 {
  padding: 24px;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  